import React from 'react'

import {
  BarPositions,
  ComboChartData,
  Serie,
} from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/chart/ComboChart/types'

import { Tick } from './Tick'

interface TickProps {
  y: number
  value: string
  index: number
  series: Serie[]
  barPositions: BarPositions
  chartData: ComboChartData[]
  formatTick?: (label: string, index: number, serieId?: string) => string
}

export const Ticks: React.FC<TickProps> = ({
  y,
  value,
  index,
  series,
  chartData,
  formatTick,
  barPositions,
}) => {
  return (
    <>
      {series.map(({ serieId, bars, lines }) => {
        return (
          <Tick
            y={y}
            bars={bars}
            key={serieId}
            lines={lines}
            value={value}
            index={index}
            serieId={serieId}
            chartData={chartData}
            formatTick={formatTick}
            barPositions={barPositions}
          />
        )
      })}
    </>
  )
}
